import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "dark-scrub-backgound" }
const _hoisted_2 = { class: "row-center" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allEngines, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "column-center",
          onClick: ($event: any) => (_ctx.$emit('setEngineIndex', index))
        }, [
          _createElementVNode("span", null, [
            _createVNode(_component_SvgIcon, {
              name: item.icon,
              size: "32px"
            }, null, 8, ["name"])
          ]),
          _createElementVNode("small", null, _toDisplayString(item.name), 1)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}